import { ArticleAuthorBio, ArticleTags } from '@/components/common/Article'
import { Disqus } from '@/components/common/Disqus'
import { Newsletter } from '@/components/common/Newsletter'
import { usePage } from '@/components/providers/PageProvider'

import styles from './ArticlePageFooter.module.scss'

export const ArticlePageFooter = () => {
  const { page } = usePage()
  const article = page?.article

  if (!article) return null

  const { author, databaseId, slug, tags, title } = article

  return (
    <footer className={styles.container}>
      <ArticleTags tags={tags} />
      <ArticleAuthorBio author={author} colorScheme='strong' />
      <Newsletter contained />
      {databaseId && <Disqus identifier={databaseId} slug={slug} title={title} />}
      <div className={styles.conduct}>
        <h3>EDHREC Code of Conduct</h3>
        <p>
          Your opinions are welcome. We love hearing what you think about <em>Magic</em>! We ask that you are always
          respectful when commenting. Please keep in mind how your comments could be interpreted by others. Personal
          attacks on our writers or other commenters will not be tolerated. Your comments may be removed if your
          language could be interpreted as aggressive or disrespectful. You may also be banned from writing further
          comments.
        </p>
      </div>
    </footer>
  )
}
